import React from "react";
import PropTypes from "prop-types";
import styles from "./index.module.css";

import OverviewLayoutContainer from "../OverviewLayout/container";
import PreviewList from "../PreviewList";
import Save from "../Save";
import PrimaryButton from "../PrimaryButton";

/**
 * Content to display when there are saved articles
 */
const WithSaved = ({ savedCount, onDownloadClick }) => {
  return (
    <div className={styles.chapterContent}>
      <div className={styles.chapterContentInner}>
        <span className={styles.divider} />
        <h2 className={styles.subTitle}>
          You have {`${savedCount}`} saved article{savedCount > 1 ? "s" : ""}
        </h2>
        <div className={styles.text}>
          <p>Download a PDF of your saved articles using the button below.</p>
          <div className={styles.download}>
            <PrimaryButton onClick={onDownloadClick}>
              Download PDF
            </PrimaryButton>
          </div>
        </div>
      </div>
    </div>
  );
};

WithSaved.propTypes = {
  savedCount: PropTypes.number,
  onDownloadClick: PropTypes.func
};

/**
 * Content to display when there are NO saved articles
 */
const WithoutSaved = () => {
  return (
    <div className={styles.chapterContent}>
      <div className={styles.chapterContentInner}>
        <span className={styles.divider} />
        <h2 className={styles.subTitle}>You have no saved articles</h2>
        <div className={styles.text}>
          <p>
            To save articles click on the star icon wherever you see it. Saved
            articles can then be downloaded as a pdf.
          </p>
          <div className={styles.exampleSave}>
            <Save />
          </div>
        </div>
      </div>
    </div>
  );
};

/**
 * Show overview content on saved articles and any saved previews.
 *
 * OVerview content changes based on whether any articles have been saved.
 */
const SavedOverview = ({
  articles,
  savedArticleIds,
  onPreviewClick,
  onDownloadClick
}) => {
  const savedArticles = articles
    .filter(article => savedArticleIds.includes(article.articleId))
    .map(article => ({ ...article, onClick: onPreviewClick }));
  const savedCount = savedArticles.length;

  return (
    <OverviewLayoutContainer
      overview={
        <div className={styles.root}>
          <h1 data-chapter={"00"} className={styles.title}>
            Saved Articles
          </h1>
          {savedCount > 0 ? (
            <WithSaved
              savedCount={savedCount}
              onDownloadClick={onDownloadClick}
            />
          ) : (
            <WithoutSaved />
          )}
        </div>
      }
      previews={<PreviewList enableAnims={true} previews={savedArticles} />}
    />
  );
};

SavedOverview.propTypes = {
  articles: PropTypes.arrayOf(
    PropTypes.shape({
      articleId: PropTypes.number
    })
  ),
  savedArticleIds: PropTypes.arrayOf(PropTypes.number),
  onDownloadClick: PropTypes.func,
  onPreviewClick: PropTypes.func
};

export default SavedOverview;



// WEBPACK FOOTER //
// ./src/components/SavedOverview/index.js